export default __webpack_public_path__ + "static/media/Fiche Organise.864449b3.pdf";